// App-wide offline indicator. Slides in a slim bar below the header when the
// device loses connectivity, and disappears when it comes back. Uses the
// browser online/offline events, which fire inside the Capacitor WebView too.
import { useEffect, useState } from "react";

function useOnline(): boolean {
  const [online, setOnline] = useState(
    typeof navigator !== "undefined" ? navigator.onLine : true,
  );
  useEffect(() => {
    const on = () => setOnline(true);
    const off = () => setOnline(false);
    window.addEventListener("online", on);
    window.addEventListener("offline", off);
    return () => {
      window.removeEventListener("online", on);
      window.removeEventListener("offline", off);
    };
  }, []);
  return online;
}

export function OfflineBanner() {
  const online = useOnline();
  // Keep it mounted (height 0) when online so the show/hide can animate.
  return (
    <div
      className={`offline-bar${online ? "" : " offline-bar--visible"}`}
      role="status"
      aria-live="polite"
    >
      <span className="offline-bar-dot" aria-hidden />
      You&rsquo;re offline, some features may be unavailable
    </div>
  );
}
